import { Injectable } from '@angular/core';
import { HorizontalPosition, NotificationType, VerticalPosition } from '../models/generic-resource-model';
import { TranslateService } from '@ngx-translate/core';
import { timer } from 'rxjs';
export { HorizontalPosition, NotificationType, VerticalPosition } from '../models/generic-resource-model';

declare const $: any;

@Injectable({ providedIn: 'root' })
export class NotificationService {

  // https://github.com/mouse0270/bootstrap-notify/blob/master/typings/bootstrap-notify/notify.d.ts

  constructor(
    private translateService: TranslateService,
  ) {
    var mainPanel = document.getElementsByClassName('main-panel')[0];
    $('.modal').on('shown.bs.modal', function () {
      mainPanel.classList.add('no-scroll');
    })
    $('.modal').on('hidden.bs.modal', function () {
      mainPanel.classList.remove('no-scroll');
    })
  }

  /**
   * 
   * @param Title 
   * @param Message 
   * @param type Type of notification [info,success,warning,danger,rose,primary]
   * @param timer 
   * @param verticalPosition 
   * @param horizontalPosition 
   */
  create(
    Title:string,
    Message: string,
    type: NotificationType,
    timer: number = 3000) {

    const colors = ['', 'info', 'success', 'warning', 'danger', 'rose', 'primary'];
    
    $.notify({
      title: Title,
      message:Message
    }, {
      type: colors[type],
      timer: type == NotificationType.danger? 6000 : timer,
      placement: { from: VerticalPosition.top, align: HorizontalPosition.right},
      template:
        `<div data-notify="container" class="front-index col-lg-4col-xs-11col-sm-8 alert alert-{0}" style="z-index: 999999 !important; min-width:300px;" role="alert">` +
        `<i class="material-icons" data-notify="icon">warning</i>` +
        '<button mat-button type="button" class="close" data-dismiss="alert" aria-label="Close">  <i class="material-icons">close</i></button>' +
        `<h5 style="margin-bottom: 0px;"><b>{1}</b></h5>` +
        '<small>{2}</small>' +
        '<div class="progress" data-notify="progressbar">' +
          '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
        '</div>' +
        '<a href="{3}" target="{4}" data-notify="url"></a>' +
      '</div>'
    });
  }
  
  createSticky(
    Title:string,
    Message: string,
    type: NotificationType,
    VerticalPosition = "top",
    HorizontalPosition = "center"
    ) {

    const colors = ['', 'info', 'success', 'warning', 'danger', 'rose', 'primary'];
    
    $.notify({
      title: Title,
      message:Message,
      
    }, {
      type: colors[type],
      placement: { from: VerticalPosition, align: HorizontalPosition},
      timer: 0,
      template:
        `<div data-notify="container" class="front-index col-lg-4 ol-xs-11col-sm-8 alert alert-{0}" style="z-index: 999999 !important; min-width:300px;" role="alert">` +
        `<i class="material-icons" data-notify="icon">warning</i>` +
        '<button mat-button type="button" class="close" data-dismiss="alert" aria-label="Close">  <i class="material-icons">close</i></button>' +
        `<h5 style="margin-bottom: 0px;"><b>{1}</b></h5>` +
        '<small>{2}</small>' +
        '<div class="progress" data-notify="progressbar">' +
          '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
        '</div>' +
        '<a href="{3}" target="{4}" data-notify="url"></a>' +
      '</div>'
    });
  }

  showNotification(from: VerticalPosition = VerticalPosition.bottom,
    align: HorizontalPosition = HorizontalPosition.right,
    type: NotificationType = NotificationType.default,
    message: string = null, icon: string = null, timer: number = 3000) {

    const colors = ['', 'info', 'success', 'warning', 'danger', 'rose', 'primary'];
    let alertClass: string = (icon != null) ? "alert-with-icon" : '';

    $.notify({
      icon: icon,
      message: message
    }, {
      type: colors[type],
      timer: timer,
      placement: {
        from: from,
        align: align
      },
      template:
        `<div data-notify="container" class="col-lg-4col-xs-11col-sm-8 alert alert-{0} ${alertClass}" style="min-width:300px;" role="alert">` +
        `<i class="material-icons" data-notify="icon">${icon}</i>` +
        '<button mat-button type="button" class="close" data-dismiss="alert" aria-label="Close">  <i class="material-icons">close</i></button>' +
        `<span data-notify="title">{1}</span>` +
        '<span data-notify="message">{2}</span>' +
        '<div class="progress" data-notify="progressbar">' +
          '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
        '</div>' +
        '<a href="{3}" target="{4}" data-notify="url"></a>' +
      '</div>'
    });
  }

  showErrorNotification(message: string, icon: string = 'priority_high') {
    this.showNotification(
      VerticalPosition.top,
      HorizontalPosition.right,
      NotificationType.danger,
      message,
      icon,
      1000);
  }

  showSuccessNotification(message: string, icon: string = null) {
    this.showNotification(VerticalPosition.top,
      HorizontalPosition.right,
      NotificationType.success,
      message,
      icon,
      1000);
  }

  showWarningNotification(message: string, icon: string = null) {
    this.showNotification(VerticalPosition.top,
      HorizontalPosition.right,
      NotificationType.warning,
      message,
      icon,
      1000);
  }
}
